import "./sidebar.css"
import {List, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {FilterAltOffOutlined, PsychologyAltOutlined} from "@mui/icons-material";
import React, {useState, useEffect} from "react";
import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import getStoredValue from "../../services/UseLocalStorage";
import {NAME_HEADER_AUTH} from "../../utils/Constants";
import BoltIcon from "@mui/icons-material/Bolt";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse } from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";


export default function SidebarComponent({
    isSidebarOpen,
    setSidebarOpen,
    showVaultGrid,
    setShowVaultGrid,
    selectedOfferSubitem,
    setSelectedOfferSubitem
}) {

    /**
     * Nombre actual de la clase que usa el sidebar.
     * @type {string}
     */
        // isSidebarOpen = true
    let classNameSideBar = isSidebarOpen ? "sidebar-component open" : "sidebar-component"
    const [listItemSelected, setListItemSelected] = useState(showVaultGrid ? 'dashboard' : 'fast genius')

    const [openNichos, setOpenNichos] = useState(false);
    
    // Collapse nichos when sidebar closes
    useEffect(() => {
        if (!isSidebarOpen && openNichos) {
            setOpenNichos(false);
        }
    }, [isSidebarOpen, openNichos]);    
    
    const handleNichosClick = () => {
        // Asegura que el sidebar se abra completamente al hacer clic en "Ofertas"
        if (!isSidebarOpen) {
            setSidebarOpen(true);
        }
        // Si el sidebar ya está abierto, simplemente alterna el colapso
        setOpenNichos(prev => !prev || !isSidebarOpen); // garantiza que se abra la sección al abrir sidebar
    };

    const handleOfferSubitemClick = (subitemName) => {
        setShowVaultGrid(false); // Ensure Biblioteca grid is hidden
        setSelectedOfferSubitem(subitemName);
        setListItemSelected(subitemName); // Optional: highlight selected subitem
    };
        

    const handleNavigation = (uri) => {
        let auth = getStoredValue(NAME_HEADER_AUTH)
        if (window.location.href !== uri) {
            switch (uri) {
                case 'dashboard':
                    setShowVaultGrid(true);
                    setSelectedOfferSubitem(null); // Reset subitem selection
                    break;
                case 'fast genius':
                    setShowVaultGrid(false);
                    setSelectedOfferSubitem(null); // Reset subitem selection
                    break;
                default:
                    window.location.href = `https://clicspy.com/${uri}?token=${auth}`; // Only navigate if the current URL is different
            }
            setListItemSelected(uri)
        }
    }

    return (
        <div className={classNameSideBar}>
            <List>
                <ListItem
                    className={listItemSelected === 'fast genius' ? "listItem-selected" : "listItem-normal"}
                    disablePadding
                    onClick={() => handleNavigation('fast genius')}
                    sx={{
                        mt: 1
                    }}>
                    <ListItemButton>
                        <ListItemIcon>
                            <BoltIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Fast Genius"/>)}
                    </ListItemButton>
                </ListItem>
                <ListItem
                    className={listItemSelected === 'dashboard' ? "listItem-selected" : "listItem-normal"}
                    disablePadding
                    onClick={() => handleNavigation('dashboard')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <PsychologyAltOutlined/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Biblioteca"/>)}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                          onClick={() => handleNavigation('funnels')}
                          sx={{width: '100%'}}>
                    <ListItemButton>
                        <ListItemIcon>
                            <FilterAltOffOutlined/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Embudos"/>)}
                    </ListItemButton>
                </ListItem>
         
                <ListItem disablePadding
                          onClick={() => window.location.href = 'https://whatsapp.com/'}
                          sx={{width: '100%'}}>
                    <ListItemButton>
                        <ListItemIcon>
                            <GroupsIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Comunidad"/>)}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{width: '100%'}} onClick={handleNichosClick}>
                    <ListItemButton>
                        <ListItemIcon>
                            <PaidIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (
                            <>
                                <ListItemText primary="Ofertas" />
                                {openNichos ? <ExpandLess /> : <ExpandMore />}
                            </>
                        )}
                    </ListItemButton>
                </ListItem>
                <Collapse in={openNichos} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{pl: isSidebarOpen ? 4 : 2}}>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Dinero")}>
                            <ListItemText primary="Dinero" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Relaciones")}>
                            <ListItemText primary="Relaciones" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Salud")}>
                            <ListItemText primary="Salud" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Gastronomía")}>
                            <ListItemText primary="Gastronomía" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Físicos")}>
                            <ListItemText primary="Físicos" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Otros")}>
                            <ListItemText primary="Otros" />
                        </ListItemButton>
                    </List>
                </Collapse>             
            </List>
        </div>
    );
}